import { navContentStore } from "@phn/state/nav-content-store";
import { h } from "@stencil/core";
import { getMenuContent } from "../../../services/menu-items-service";
import { isDesktop } from "@phn/utility/helper";
import { TVehiclePurchaseMenu } from "@phn/entities/content";

interface VehiclePurchaseSectionTypes {
  activeRoutingKey: string;
  topLevelRoutingKey: string;
  breakpoint: number;
  receivedContent: boolean;
}

export default function VehiclePurchaseSection({
  activeRoutingKey,
  topLevelRoutingKey,
  breakpoint,
  receivedContent,
}: VehiclePurchaseSectionTypes): HTMLElement {
  const showHeadline = !isDesktop(breakpoint);
  const displayedContent = getMenuContent(
    navContentStore.state,
    activeRoutingKey,
    topLevelRoutingKey,
  ) as TVehiclePurchaseMenu;

  /* istanbul ignore if */
  if (displayedContent === null) {
    return <div></div>;
  }

  return (
    <phn-nd-menu
      item={displayedContent}
      showHeadline={showHeadline}
      receivedContent={receivedContent}
    />
  );
}
